import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UsersIcon } from '@heroicons/react/24/outline';

import { ROUTES } from '@/utils/routes';
import { Button, SmartTableCellProps } from '@/components/ui/daisy';

import { ScheduledLessonWithKlass } from '../types';

export default function ActionsCell({
  item,
}: SmartTableCellProps<ScheduledLessonWithKlass>) {
  const { t } = useTranslation('translation', { keyPrefix: 'pendencies' });
  const navigate = useNavigate();

  const reportLink = ROUTES.CLASS.LESSON_REPORT(item.klass.id, item.id);

  return (
    <Button
      size="sm"
      color="warning"
      variant="soft"
      onClick={() => navigate(reportLink)}
    >
      <UsersIcon className="w-4" />
      {t('viewReport')}
    </Button>
  );
}
